var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coordinacion-convenios"},[_c('div',{staticStyle:{"background":"#E0F7FA","padding":"5px 10px","border-bottom":"1px solid #00BCD4"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"sm":12,"offset":0}},[_c('h4',{staticStyle:{"margin":"10px 20px"}},[_vm._v("COORDINACIÓN DE RECETAS / CONVENIOS")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }